// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"607":"77bc9aae","668":"861b2afb","787":"efcd9f72"}[chunkId] + ".chunk.js";
};